import React from 'react';
import { isNumber } from 'lodash';
import { useChannelsStateStore } from '../../../store/channels-state';
import { ChannelMeterStateType, ChannelType } from '../../../types';
import { EcoBar } from '../eco-bar';

type EcoRatioProps = {
  channel: ChannelType;
};

export const EcoRatio: React.FC<EcoRatioProps> = ({ channel }) => {
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as ChannelMeterStateType | null;
  const ecoRatio = state?.ecoRatio;

  return isNumber(ecoRatio) ? <EcoBar value={ecoRatio} maxValue={100} className="m-t-4" /> : null;
};
